import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { ensureDLToken, clearDLToken } from "@/lib/dlToken";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);     // null = checking, false = logged out, object = logged in
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("pr_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        // Pre-mint a short-lived download token so synchronous URL builders
        // (logos, label PDFs, file thumbnails) have an `?auth=` value
        // ready on first render. SEC-003.
        ensureDLToken().catch(() => {});
      })
      .catch(() => {
        localStorage.removeItem("pr_token");
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("pr_token", data.token);
    setUser(data.user);
    ensureDLToken().catch(() => {});
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("pr_token");
    clearDLToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};
